export default "__VITE_ASSET__ddea5f40__"